module.exports = __webpack_public_path__ + "b.no1.22e7ae4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/b.no1.jpg
// module id = uwrZ
// module chunks = 0